import api from '../../../services/api';

const shmSensorService = {
  getLive: () => api.get('/sensors/live'),

  getLatest: (sensorId) => api.get(`/sensors/${sensorId}/latest`),

  getHistory: (sensorId, params) => api.get(`/sensors/${sensorId}/history`, params),
};

export default shmSensorService;
